import { useEvent, useState } from '../../hooks'
import M from 'materialize-css'
import { modalCloseButtonHandler } from './constant'
import { getModalCloseButtonHandlerComponents } from './selector'

type State = {
	buttons: NodeListOf<HTMLElement>
}

export const ModalCloseButtonHandler = (() => {
	const { state, setState } = useState<State>()

	const initCloseButton = () => {
		const { buttons } = state

		if (buttons.length === 0) {
			return
		}

		buttons.forEach((button) => {
			const modalId = button.getAttribute(modalCloseButtonHandler.selector.button)

			if (modalId === null) {
				return
			}

			const click = useEvent<MouseEvent>(button, 'click')
			click.register(() => {
				const modalElement = document.getElementById(modalId)

				if (modalElement === null) {
					return
				}

				const modal = M.Modal.getInstance(modalElement)
				// eslint-disable-next-line no-unused-expressions
				modal?.close()
			})
		})
	}
	const init = () => {
		setState({ ...getModalCloseButtonHandlerComponents() })

		initCloseButton()
	}

	return {
		init,
	}
})()
